/**
 * Safe console methods. Import named methods from here,
 * instead of using the global 'console' objects and it's methods.
 */

function noop() {}
const c = console
const boundConsole = Object.create(null)
const UNSAFE_CONSOLE_METHOD_NAMES = ['group', 'groupEnd', 'collapsedGroup', 'NON_EXISTANT_METHOD']

function makeSafeConsoleMethod(methodName, method) {
  // For some strange reason, console methods aren't "instanceof Function" in Firebug.
  if (typeof method !== 'function') {
    method = noop // eslint-disable-line no-param-reassign
  }
  let boundMethod
  try {
    boundMethod = method.bind(c)
    boundMethod.curry = (...args) => method.bind(c, ...args)
  } catch (e) {
    boundMethod = noop
    boundMethod.curry = noop
  } finally {
    // From some reason function.name didn't work here, so I added this custom property.
    boundMethod.methodName = methodName
    boundConsole[methodName] = boundMethod
  }
}

UNSAFE_CONSOLE_METHOD_NAMES.forEach(makeSafeConsoleMethod)

// We can't simply do Object.entries(c).forEach(makeSafeConsoleMethod) or Object.keys(c)
// because webkit is the new IE ಠ_ಠ
for (let methodName in c) {
  let method = c[methodName]
  makeSafeConsoleMethod(methodName, method)
}

export const warn = boundConsole.warn
export const error = boundConsole.error
export const info = boundConsole.info
export const log = boundConsole.log
export const groupCollapsed = boundConsole.groupCollapsed
export const groupEnd = boundConsole.groupEnd
export const group = boundConsole.group



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/console.js